module.exports = __webpack_public_path__ + "img/modulos_i_o.dd05b6a4.jpg";